import { useRouter, usePathname } from '@/i18n/routing';

//* Context
import { withUIContext } from '@/context';

//* Helpers
import { config } from '@/helpers';

//* Styles
import LogoStyle from './style';

//* SVG
import { logoSvg } from './util';

const Logo = ({ isBurgerMenuOpen, closeBurgerMenu }) => {
	const router = useRouter();
	const pathname = usePathname();

	const handleLogoClick = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});

		if (pathname == config.routes.home.path && isBurgerMenuOpen) {
			closeBurgerMenu();
		} else {
			router.push(config.routes.home.path);
		}
	};

	return (
		<LogoStyle className={'cursor-pointer'}>
			<div onClick={handleLogoClick}>{logoSvg}</div>
		</LogoStyle>
	);
};

export default withUIContext(Logo, ['isBurgerMenuOpen', 'closeBurgerMenu']);
